import i18n, { type Resource } from 'i18next'
import { initReactI18next } from 'react-i18next'
import enCommon from './locales/en/common.json'
import jaCommon from './locales/ja/common.json'

const resources = {
  en: {
    common: enCommon,
  },
  ja: {
    common: jaCommon,
  },
} as const

export type SupportedLocale = keyof typeof resources
export const supportedLocales = Object.keys(resources) as SupportedLocale[]

const normalizeLocale = (locale?: string): SupportedLocale => {
  if (locale && supportedLocales.includes(locale as SupportedLocale)) {
    return locale as SupportedLocale
  }

  // Try to match first two characters (e.g., en-US -> en)
  if (locale) {
    const short = locale.split('-')[0] as SupportedLocale
    if (supportedLocales.includes(short)) {
      return short
    }
  }

  return 'en'
}

let initialized = false

export const initI18n = (locale?: string) => {
  const normalizedLocale = normalizeLocale(locale) as string

  if (initialized) {
    i18n.changeLanguage(normalizedLocale)
    return i18n
  }

  i18n.use(initReactI18next).init({
    resources: resources as Resource,
    lng: normalizedLocale,
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
  })

  initialized = true

  return i18n
}
